import { all, takeLatest, call, put } from 'redux-saga/effects';

import { getPatientInfo } from '../services';
import { captureException } from 'shared/utils/handlerErrors';
import {
  patientError,
  patientInfo,
  patientPending,
  patientSuccess,
} from './patient';

export function* workerPatientInfo({ payload: id }: { payload: string }) {
  yield put(patientPending());

  try {
    const {
      data: {
        name,
        birthdate_in_years,
        occupation,
        last_insurance_name,
        picture,
      },
    } = yield call(getPatientInfo, id);

    yield put(
      patientSuccess({
        name,
        birthdate_in_years,
        occupation,
        last_insurance_name,
        picture,
      }),
    );
  } catch (error: any) {
    yield put(patientError(error.message));
    yield call(captureException, error);
  }
}

export default function* rootSaga() {
  yield all([takeLatest(patientInfo, workerPatientInfo)]);
}
